import React from 'react'
import styles from './styles.module.scss'
import Image from 'next/image'
import { useAppIntl } from 'src/i18n'

export const SummaryModal = ({ pros, cons, summary }) => {
  const prosArray = pros && Array.isArray(pros.data) ? pros.data : []
  const consArray = cons && Array.isArray(cons.data) ? cons.data : []
  const intl = useAppIntl()

  return (
    <div>
      <div className={styles.main}>
        <div className={styles.mainUpper}>
          <h4>{intl.t('review.item.summary')}</h4>
          <p>{summary}</p>
        </div>
        <div className={styles.mainLower}>
          <div className={styles.mainLowerleft}>
            <h5>{intl.t('review.item.pros')}</h5>
            <section className={styles.proSection}>
              {prosArray.length > 0 ? (
                <ul>
                  {prosArray.map((pro, index) => (
                    <li key={index}>
                      {' '}
                      <Image
                        className={styles.proIcon}
                        src='/assets/icons/icon-check-circle.svg'
                        width={17}
                        height={17}
                        layout='fixed'
                        objectFit='cover'
                        alt='Pros-icon'
                      />
                      <div className={styles.proDescription}>
                        {pro.attributes.description}
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>{intl.t('review.item.nopros')}</p>
              )}
            </section>
          </div>
          <div className={styles.mainLowerRight}>
            <h5>{intl.t('review.item.cons')}</h5>
            {consArray.length > 0 ? (
              <ul>
                {consArray.map((con, index) => (
                  <li key={index}>
                    {' '}
                    <Image
                      className={styles.proIcon}
                      src='/assets/icons/icon-cross-circle.svg'
                      width={17}
                      height={17}
                      layout='fixed'
                      objectFit='cover'
                      alt='Con-icon'
                    />
                    <div className={styles.proDescription}>
                      {con.attributes.description}
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p>{intl.t('review.item.nocons')}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
